import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-at_the_beginning",
  "use": "icon-at_the_beginning-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-at_the_beginning\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12,20a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM12,5.45A6.55,6.55,0,1,0,18.55,12,6.56,6.56,0,0,0,12,5.45Zm2.72,6.25L11.2,9.07a.5.5,0,0,0-.8.41v5.24a.5.5,0,0,0,.8.41l3.52-2.63A.5.5,0,0,0,14.72,11.7Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol